import React from 'react';

function ClientsBenefitsIcon4() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="32"
      fill="none"
      viewBox="0 0 28 32"
    >
      <g clipPath="url(#clip0_257_863)">
        <path
          fill="#1B1F2C"
          d="M14 16a8 8 0 008-8 8 8 0 00-8-8 8 8 0 00-8 8 8 8 0 008 8zm5.988 2.038L17 30l-2-8.5 2-3.5h-6l2 3.5-2 8.5-2.988-11.962C3.556 18.25 0 21.894 0 26.4V29a3 3 0 003 3h22a3 3 0 003-3v-2.6c0-4.506-3.556-8.15-8.012-8.362z"
        />
      </g>
      <defs>
        <clipPath id="clip0_257_863">
          <path fill="#fff" d="M0 0H28V32H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default ClientsBenefitsIcon4;
